import React, {useCallback} from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import LockToPlanContainer from '../../../../components/Editor/LockToPlanContainer';
import BaseDns from '../../AbstractObjects/GatewayPlan/InnerPages/BaseDns';
import {useTranslation} from 'react-i18next';
import Indentation from '../../../../components/Simple/Indentation';
import SMCLink from '../../../../components/Simple/SMCLink';
import {doSeamlessLogin} from '../../../../utils/utils';
import SMCIcon from '../../../../components/Simple/SMCIcon';
import {dnsIcon} from '../../../../assets/images/headerIcons'
const pageSchema = GatewayGetSchema.pages.dns;
const pageId = pageSchema.pageId;

function GatewayDns({
    gatewayObject,
    planObject,
    setGatewayData
}) {
    const { t } = useTranslation();

    const gatewayPage  = gatewayObject[pageId];
    const planPage     = planObject[pageId];
    const lockedToPlan = gatewayPage[pageSchema.lockedToPlan];

    let currentPageData;
    if (lockedToPlan) {
        currentPageData = planPage;
    } else {
        currentPageData = gatewayPage;
    }

    const onToggleLockedToPlan = useCallback((locked) => {
        // If unlocked page from plan, set all gateway fields to plan's fields
        if (!locked) {
            setGatewayData([pageId, pageSchema.manageInSmp], planPage[pageSchema.manageInSmp]);
            setGatewayData([pageId, pageSchema.configureDnsServers], planPage[pageSchema.configureDnsServers]);
            setGatewayData([pageId, pageSchema.firstDnsServer], planPage[pageSchema.firstDnsServer]);
            setGatewayData([pageId, pageSchema.secondDnsServer], planPage[pageSchema.secondDnsServer]);
            setGatewayData([pageId, pageSchema.thirdDnsServer], planPage[pageSchema.thirdDnsServer]);
            setGatewayData([pageId, pageSchema.enableDnsProxy], planPage[pageSchema.enableDnsProxy]);
            setGatewayData([pageId, pageSchema.resolveNetworkObjects], planPage[pageSchema.resolveNetworkObjects]);
            setGatewayData([pageId, pageSchema.domainName], planPage[pageSchema.domainName]);
        }        
        setGatewayData([pageId, pageSchema.lockedToPlan], locked);

    }, [setGatewayData, planPage]);

    return (
        <>
        <LockToPlanContainer
            locked={lockedToPlan}
            onToggleLocked={onToggleLockedToPlan}
            labelText={t('SMP.GATEWAYS.INNER_MENU.DNS')}
            icon={dnsIcon}
        >
            <BaseDns
                pageData={currentPageData}
                setObjectData={setGatewayData}
                pageDisabled={lockedToPlan}
            />
        </LockToPlanContainer>
        <Indentation>
            <SMCLink onClick={() => doSeamlessLogin(gatewayObject.id, null, 'app.DNS')}><SMCIcon style={{ verticalAlign: 'middle' }} icon="seamlessLogin" /> {t('SMP.ACCESS_GATEWAY.DNS')}</SMCLink>
        </Indentation>
        </>
    );
}

export default GatewayDns;